export default "__VITE_ASSET__Cfys8iET__"